import styled from 'styled-components';

import Drawer from '../../../../newComponents/Drawer';
import PrimitiveModal from '../../../../newComponents/Modal';
import PrimitiveTabPanel from '../../../../newComponents/TabPanel';

export const Container = styled(Drawer)`
  display: flex;
  flex: 1;
  flex-direction: column;

  form {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100vh;

    header {
      width: 100%;
      padding: 32px 32px 20px;

      div.drawer-title {
        display: flex;
        align-items: center;
        justify-content: space-between;

        h1 {
          color: #101d40;
          font-size: 24px;
          font-family: 'Sora', sans-serif;
          font-weight: 700;
        }

        button {
          background: none;
          border: none;

          svg {
            font-size: 36px;
            color: #f64444;
          }
        }
      }

      h3 {
        color: #7c8db5;
        font-weight: 400;
        padding-top: 5px;
        font-size: 16px;
        font-family: 'Sora', sans-serif;
        padding-bottom: 15px;

        strong {
          font-weight: 600;
          color: #101d40;
        }
      }

      @media only screen and (max-width: 768px) {
        padding: 20px;
      }
    }

    main {
      overflow-x: hidden;
      overflow-y: auto;
    }

    footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 20px 32px 32px;
      gap: 15px;
      margin-top: auto;

      @media only screen and (max-width: 768px) {
        flex-direction: column;
        padding: 20px;
        gap: 10px;

        button {
          width: 100%;
        }
      }
    }
  }
`;

export const TabPanel = styled(PrimitiveTabPanel)`
  overflow-x: hidden;
  overflow-y: auto;
`;

export const Modal = styled(PrimitiveModal)`
  gap: 10px;
  position: relative;
  padding: 28px 32px;
  border-radius: 8px;
  max-width: 400px;
  font-family: 'Sora', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    text-align: center;
    /* margin-top: 10px; */
    font-family: 'Sora', sans-serif;
    font-size: 14px;
    color: #7c8db5;
    margin-bottom: 10px;

    strong {
      color: #101d40;
      font-weight: 600;
      margin-top: 5px;
    }
  }

  /* button {
    & + button {
      margin-top: 15px;
    }
  } */
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(246, 68, 68, 0.2);
    margin: none;

    svg {
      color: #f64444;
      font-size: 50px;
    }
  }

  h1 {
    color: #101d40;
    font-size: 24px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);

    svg {
      color: #4f4f4f;
      font-size: 22px;
    }

    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;
